import Documents from "../Documents";
import OnboardingDocumentModuleProvider from "../Provider/OnboardingDocumentModuleProvider";

interface CommonDocumentModuleInterfaceProps {
  isView?: boolean;
  userId?: string;
  isTimeline?: boolean;
  isApprovedView?: boolean;
}

const CommonDocumentModuleInterface = ({
  isView,
  userId,
  isTimeline,
  isApprovedView,
}: CommonDocumentModuleInterfaceProps) => {
  return (
    <>
      <OnboardingDocumentModuleProvider>
        <Documents
          isView={isView}
          userId={userId}
          isTimeline={isTimeline}
          isApprovedView={isApprovedView}
        />
      </OnboardingDocumentModuleProvider>
    </>
  );
};

export default CommonDocumentModuleInterface;
